'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getQueries = exports.getClient = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _apolloClient = require('apollo-client');

var _lodash = require('lodash.merge');

var _lodash2 = _interopRequireDefault(_lodash);

var _buildApolloConfiguredClient = require('./buildApolloConfiguredClient');

var _buildApolloConfiguredClient2 = _interopRequireDefault(_buildApolloConfiguredClient);

var _realtime = require('./realtime');

var _realtime2 = _interopRequireDefault(_realtime);

var _introspection = require('./introspection');

var _introspection2 = _interopRequireDefault(_introspection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getClient = function getClient(_ref) {
    var client = _ref.client,
        clientOptions = _ref.clientOptions;

    if (client) return client;

    if (clientOptions) {
        var networkInterface = clientOptions.networkInterface,
            uri = clientOptions.uri,
            options = (0, _objectWithoutProperties3.default)(clientOptions, ['networkInterface', 'uri']);


        if (networkInterface) {
            if (networkInterface && uri) {
                console.error('Warning: You specified a networkInterface and an uri option. uri will be ignored.');
            }
            return new _apolloClient.ApolloClient((0, _extends3.default)({}, options, { networkInterface: networkInterface }));
        }

        if (!networkInterface && uri) {
            options.networkInterface = (0, _apolloClient.createNetworkInterface)({ uri: uri });
        }

        return new _apolloClient.ApolloClient(options);
    }

    return new _apolloClient.ApolloClient();
};

exports.getClient = getClient;
var getQueries = exports.getQueries = function getQueries(buildQueriesFromIntrospectionImpl) {
    return function () {
        var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(options) {
            var queriesFromIntrospection;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            if (!(options.queries && options.introspection === false)) {
                                _context.next = 2;
                                break;
                            }

                            return _context.abrupt('return', options.queries);

                        case 2:
                            _context.next = 4;
                            return buildQueriesFromIntrospectionImpl((0, _extends3.default)({
                                client: options.client
                            }, options.introspection));

                        case 4:
                            queriesFromIntrospection = _context.sent;
                            return _context.abrupt('return', (0, _lodash2.default)({}, queriesFromIntrospection, options.queries));

                        case 6:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined);
        }));

        return function (_x) {
            return _ref2.apply(this, arguments);
        };
    }();
};

/**
 * Maps admin-on-rest queries to an Apollo GraphQL endpoint
 * @param {Object} options
 */

exports.default = function () {
    var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(options) {
        var finalOptions, client, queries, apolloConfiguredClient, aorClient;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        finalOptions = options;


                        if (!options) {
                            finalOptions = {};
                        }
                        client = getClient(finalOptions);

                        finalOptions.client = client;

                        _context2.next = 6;
                        return getQueries(_introspection2.default)(finalOptions);

                    case 6:
                        queries = _context2.sent;
                        apolloConfiguredClient = (0, _buildApolloConfiguredClient2.default)(client, queries);
                        /**
                         * @param {string} type Request type, e.g GET_LIST
                         * @param {string} resource Resource name, e.g. "posts"
                         * @param {Object} payload Request parameters. Depends on the request type
                         * @returns {Promise} the Promise for a REST response
                         */

                        aorClient = function aorClient(type, resource, params) {
                            return apolloConfiguredClient.handleRequest(type, resource, params);
                        };

                        aorClient.saga = function (apolloWatchOptions) {
                            return (0, _realtime2.default)(apolloConfiguredClient, apolloWatchOptions);
                        };

                        return _context2.abrupt('return', aorClient);

                    case 11:
                    case 'end':
                        return _context2.stop();
                }
            }
        }, _callee2, undefined);
    }));

    return function (_x2) {
        return _ref3.apply(this, arguments);
    };
}();


//////////////////
// WEBPACK FOOTER
// ./~/aor-simple-graphql-client/lib/buildApolloClient.js
// module id = 925
// module chunks = 0